import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useActivityContext } from '../../../../context/activity-store';
import { StyledPrimaryButton } from '../../../../styles/buttons';
import { StyledModalActions } from '../subcomponents';
var ModalFooter = function (_a) {
    var closeModal = _a.closeModal;
    var t = useTranslation().t;
    var isDisplayCondensed = useActivityContext().isDisplayCondensed;
    return (_jsx(StyledModalActions, { justifyContent: "end", alignItems: "center", children: _jsx(StyledPrimaryButton, { className: "ensightencustomevent", "data-analytics": "clicktrackingevent", "data-object": "button", "data-reason": "close", "data-type": "close", onClick: closeModal, children: isDisplayCondensed ? t('common.backButton') : t('common.closeButton') }) }));
};
export default ModalFooter;
//# sourceMappingURL=index.js.map